import React from 'react';
import PropTypes from 'prop-types';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconHelpCircle } from 'svgIcons/MotionPortalIcons';
import { translate } from 'helpers/translateHelper';

const HierarchyInfoModal = ({ isOpen, onClose }) => {
    return (
        <GeneralDialog
            show={isOpen}
            close={onClose}
            title={
                <div className='hierarchy-help-title'>
                    <IconHelpCircle />
                    <span>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalTitle')}</span>
                </div>
            }
            modalClassName='hierarchy-help-dialog'
            backdropClassName='hierarchy-help-backdrop'
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.closeBtnLbl'),
                onClick: onClose
            }}
            closeButton={true}
        >
            <div className='hierarchy-help-content'>
                <p>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalContent')}</p>
                <div>
                    <span className='title'>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalSection1')}</span>
                    <ol>
                        <li>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalPoint1')}</li>
                        <li>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalPoint2')}</li>
                        <li>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalPoint3')}</li>
                    </ol>
                </div>
                <div>
                    <span className='title'>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalSection2')}</span>
                    <ol>
                        <li>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalPoint4')}</li>
                        <li>{translate('ABB.Powertrain.Frontend.hierarchyInfoModalPoint5')}</li>
                    </ol>
                </div>
            </div>
        </GeneralDialog>
    );
};

HierarchyInfoModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default HierarchyInfoModal;
